module.exports = __webpack_public_path__ + "static/media/LoadingWithoutBG.38264802.gif";